const SELECTOR = '[data-flash-message]';
const CLOSE_BUTTON_SELECTOR = `${SELECTOR} .close`;
const IS_PERMANENT = '.permanent';

class FlashMessages {
  constructor() {
    this.attachEventHandlers();
  }

  close() {
    $(SELECTOR).fadeOut(500);
  }

  attachEventHandlers() {
    $('body').on('click touchend', CLOSE_BUTTON_SELECTOR, this.close);
    setTimeout(function() {
      $(`${SELECTOR}:not(${IS_PERMANENT})`)
        .fadeOut(500)
        .bind(this);
    }, 5000);
  }
}

export default FlashMessages;



// WEBPACK FOOTER //
// ./src/javascripts/FlashMessages.js